export default __webpack_public_path__ + "static/media/sneaker_street.76b475ca.jpg";